module.exports = __webpack_public_path__ + "static/Wagestream-bb8b2c9653f83c12945483f59e749e2b.jpg";